import { useMutation } from '@apollo/client/react';
import { useSetAtom } from 'jotai';
import { useCallback, useEffect, useState } from 'react';

import { DeleteTracingReportDraftDocument } from '~/graphql/generated/graphql';
import { tracingReportPaneState } from '~/state/partials/tracingreport_panel/atoms';

export const useDeleteTracingReportDraft = (tracingReportDraftId: string | null) => {
  const [error, setError] = useState<string | null>(null);
  const setTracingReportPaneState = useSetAtom(tracingReportPaneState);
  const [deleteTracingReportDraft, { data }] = useMutation(DeleteTracingReportDraftDocument);

  useEffect(() => {
    if (!data?.deleteTracingReportDraft) return;

    setTracingReportPaneState((state) => ({
      ...state,
      tracingReportDraftId: null,
    }));
  }, [data, setTracingReportPaneState]);

  const deleteDraft = useCallback(async () => {
    if (!tracingReportDraftId) return;

    setError(null);

    try {
      await deleteTracingReportDraft({
        variables: {
          input: {
            tracingReportDraftId,
          },
        },
      });
    } catch (_error) {
      setError(_error?.message || 'エラーが発生しました');
      throw new Error('', { cause: _error });
    }
  }, [tracingReportDraftId, deleteTracingReportDraft]);

  return {
    error,
    setError,
    deleteDraft,
  };
};
